import {Types} from 'mongoose';
import * as r from './referral-mediums.const';

export const REFERAL_MEDIUMS = {
    type: 'Referral Mediums',
    category: 'General',
    value: [
        {label: r.REFERAL_MEDIUMS_EMAIL_OR_PHONE.label, _id: new Types.ObjectId(r.REFERAL_MEDIUMS_EMAIL_OR_PHONE._id)},
        {label: r.REFERAL_MEDIUMS_IN_PERSON.label, _id: new Types.ObjectId(r.REFERAL_MEDIUMS_IN_PERSON._id)},
        {label: r.REFERAL_MEDIUMS_OTHER.label, _id: new Types.ObjectId(r.REFERAL_MEDIUMS_OTHER._id)},
    ].map(d => ({...d, active: true})),
};
